import { TextInput } from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const colorFilterList = [
  // <TextInput
  //   source="all"
  //   label="mine.filter.search_all"
  //   variant="outlined"
  //   alwaysOn
  //   resettable
  //   InputProps={{
  //     endAdornment: (
  //       <InputAdornment position="end">
  //         <SearchIcon />
  //       </InputAdornment>
  //     ),
  //   }}
  // />,
  <TextInput
    source="name"
    label="mine.label.name"
    variant="outlined"
    alwaysOn
    resettable
  />,
  <TextInput
    source="code"
    label="mine.label.code"
    variant="outlined"
    resettable
    alwaysOn
  />,
];

export default colorFilterList;
